module.exports = __webpack_public_path__ + "img/g2.326661df.jpg";